import { normalizeUrl } from '@/helpers/normalize-url';

export const prepareLink = (link?: string): string =>
  link ? normalizeUrl(link) : '';
